module.exports = __webpack_public_path__ + "static/media/matt.3ce1f021.jpg";